import React from 'react';
import callApi from '../../../utils/callApi';
import { ANCHOR_PRIVATE_GALLERIES } from '../../../constants/apiUrls/apiUrls';
import NewGalleryModal from './NewGalleryModal';
import Loading from 'react-simple-loading';
import { capitalize } from '../../../utils/helpers';
import './AnchorGalleries.css';
import NoData from '../../../components/generalComponents/NoData/NoData';
import defaultGalleryImage from '../../../assets/default-gallery.png';
import AnchorDashboardHeader from '../../../components/AnchorDashboardHeader/AnchorDashboardHeader';

class AnchorGalleries extends React.PureComponent {

  state = {
    galleries: [],
    loading: true,
    showGalleryModal: false
  };

  componentDidMount() {
    this.fetchGalleries();
  }

  fetchGalleries = () => {
    const { user } = this.props;
    const anchorId = user.user.account.anchor.id;

    const privateGalleriesUrl = ANCHOR_PRIVATE_GALLERIES.replace('{id}', anchorId);
    callApi(privateGalleriesUrl, 'GET', undefined, undefined, undefined, true, true, true)
    .then(res => {
      if (res.status === 200 && res.data) {
        this.setState({ galleries: res.data });
      }
      this.setState({ loading: false });
    })
    .catch(error => {
      console.error(error);
      this.setState({ loading: false });
    });
  }

  openGalleryModal = () => {
    this.setState({ showGalleryModal: true })
  }

  closeGalleryModal = () => {
    this.setState({ showGalleryModal: false })
  }

  displayGalleries = () => {
    const { galleries } = this.state;
    return (
      <div className="content-grid-container">
        <div className="content-grid">
        {
          galleries.map(gallery => {
            const galleryLength = gallery.images.length;
            const galleryLink = `/dashboard/galleries/${gallery.id}`;
            const galleryCover = gallery.mainImage ? gallery.mainImage : defaultGalleryImage;
            return (
              <div key={gallery.id} className="content-item-container">
                  <a className="content-item " href={galleryLink}>
                      <div 
                        className="anchor-gallery-content-item-thumbnail" 
                        style={{
                          background: `url(${galleryCover})
                          no-repeat top center /
                          ${gallery.mainImage ? 'cover' : 'contain'}`,
                          backgroundColor: `${gallery.mainImage ? '' : '#a6a6a6'}`
                        }}>
                          <div className="content-item-title-mobile">
                              {gallery.name.toUpperCase()}
                          </div>
                      </div>
                      <div className="content-item-caption anchor-galleries-content-caption">
                        <div className="content-item-title anchor-galleries-content-item-title">
                            {gallery.name.toUpperCase()}
                        </div>
                        <div className="content-item-category anchor-galleries-content-item-category">
                            {`${galleryLength} ${galleryLength === 1 ? 'Image' : 'Images'}`}
                        </div>
                      </div>
                  </a>
              </div>
            )
          })
        }
        </div>
      </div>
    )
  }

  render() {
    const { loading, showGalleryModal, galleries } = this.state;
    const { user } = this.props;
    const noData = galleries.length === 0;
    return (
      loading ? <Loading /> :
        <div className="content anchor-dashboard-min-height">
          <AnchorDashboardHeader heading={'Galleries'} />
          <div className="container">
            <div className="anchor-gallery-head">
              <div className="galleries-description">
                <p className="galleries-info"></p>
                <button
                  className="btn btn-danger btn-block montserrat caps create-gallery-button"
                  onClick={this.openGalleryModal}
                >
                  Create New
                </button>
              </div>
            </div>
            {this.displayGalleries()}
          </div>
          <NewGalleryModal
            user={user}
            showModal={showGalleryModal}
            close={this.closeGalleryModal}
            fetchGalleries={this.fetchGalleries}
          />
          {noData ? <NoData category="Galleries" /> : null}
        </div>

    )
  }
}

export default AnchorGalleries;
